import { Stack, Container, Alert, Autocomplete, Typography, TextField, Divider } from "@mui/material";
//zui 
import { Button } from 'src/@/components/ui/button';
import { Card, CardContent } from 'src/@/components/ui/card';
import { Label } from 'src/@/components/ui/label';
import { Input } from 'src/@/components/ui/input';
import { RowInput } from 'src/components/forms/RowInput';
import { RadioGroup, RadioGroupItem } from 'src/@/components/ui/radio-group';

import { Switch } from 'src/@/components/ui/switch';
import SelectVoice from "./components/SelectVoice";
import ContainerOptions from "../components/ContainerOptions";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "src/@/components/ui/tooltip";
import InputStyleMultline from "src/components/InputStyleMultline";
import { Textarea } from "src/@/components/ui/textarea";
import { ZuiAlert } from "src/@/components/use/alert";
import { Badge } from "src/@/components/ui/badge";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "src/@/components/ui/accordion"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select";
import { Row } from "react-day-picker";
import { verifyRules } from "src/utils/functions";


export default function AiAgentConfigTab({
    aiAgent,
    listTypeVoices,
    voice,
    changeVoice,
    awnserAudio,
    changeAwnserAudio,
    changeAgentType,
    changeListenMsgs,
    changeAllowsInChat,
    changeDelayBetweenMsgs,
    changeLengthSendVoice,
    changeLimitSendVoice,
    changeLastContext,
    onChangeMsgs,
    changeConfigTools,
    changeCustomModelAi,
    calendars,
    user
}) {

    // Defina aqui a sua regra para liberar o avançado
    // Exemplo: só libera se o agent_type atual for 'avancado' (ajuste conforme sua regra)
    const podeUsarAvancado = verifyRules(user?.rules, 'ia.agente.avancado');

    // Função para gerenciar a mudança do modelo de IA
    const handleModeloIAChange = (value) => {
        if (aiAgent?.config?.generalConfig) {
            aiAgent.config.generalConfig.modelo_ia = value;
        }
        console.log('Modelo de IA selecionado:', value);
    };

    // Verifica se as opções de tipo de agente devem estar desabilitadas
    const isTipoAgenteDisabled = aiAgent?.config?.generalConfig?.modelo_ia;

    const optionsTipoAgente = [
        { value: 'basic', label: 'Básico', desc: 'Pode ser um modelo maior e mais robusto, capaz de lidar com tarefas complexas e gerar textos mais longos e coesos.' },
        ...(podeUsarAvancado
            ? [{ value: 'advanced', label: 'Avançado', desc: 'Destinado a tarefas mais simples ou onde o desempenho em tempo real é crucial. Modelos "mini" são geralmente mais rápidos e exigem menos recursos computacionais.' }]
            : [])
    ];

    const optionsTypeVoices = [
        {
            value: 'never',
            label: 'Nunca',
            desc: 'O agente sempre responderá com texto as mensagens'

        },
        {
            value: 'responseAudio',
            label: 'Responder aúdio',
            desc: 'O agente responderá com áudio somente se a mensagem do usuário for um áudio'
        },
        {
            value: 'always',
            label: 'Sempre',
            desc: 'O agente sempre responderá com áudio'
        },
        {
            value: 'random',
            label: 'Randômico',
            desc: 'O agente responderá com áudio de forma aleatória'
        }
    ];

    const optionsAllowsInChat = [
        {
            "value": "ptt",
            "label": "Mensagem de voz"
        },
        {
            "value": "audio",
            "label": "Mensagem de audio"
        },
        {
            "value": "image",
            "label": "Imagens"
        },
        {
            "value": "video",
            "label": "Videos"
        },
        {
            "value": "document",
            "label": "Documentos"
        }
    ]

    const optionsModeloIA = [
        {
            value: 'gpt-4o',
            label: 'GPT-4o',
            desc: 'Modelo mais usado e com melhor performance'
        },
        {
            value: 'gpt-4o-mini',
            label: 'GPT-4o Mini',
            desc: 'Versão otimizada do GPT-4o com melhor performance e custo mais acessível'
        },
        {
            value: 'gpt-4-nano',
            label: 'GPT-4 Nano',
            desc: 'Modelo GPT-4 mais leve e rápido e com custo mais acessível'
        },
        {
            value: 'gpt-4.1',
            label: 'GPT-4.1',
            desc: 'Modelo atualizado da série GPT-4 com melhorias de performance'
        },
        {
            value: 'gpt-4.1-mini',
            label: 'GPT-4.1 Mini',
            desc: 'Versão otimizada do GPT-4.1 com melhor performance e custo mais acessível'
        },
        {
            value: 'gpt-5',
            label: 'GPT-5',
            desc: 'Modelo mais avançado da OpenAI'
        },
        {
            value: 'gpt-5-mini',
            label: 'GPT-5 Mini',
            desc: 'Versão otimizada do GPT-5 com melhor performance e custo mais acessível'
        },
        {
            value: 'gpt-5-nano',
            label: 'GPT-5 Nano',
            desc: 'Versão otimizada do GPT-5 mais leve e rápido e com custo mais acessível'
        },
        {
            value: 'o3-mini',
            label: 'o3-mini',
            desc: 'Modelo da família O3 com características únicas'
        }

    ];

    const newOptionsAllowsInChat = optionsAllowsInChat.filter(item => aiAgent?.config?.generalConfig?.allowsInChat.includes(item.value));

    console.log(aiAgent?.config?.generalConfig?.customModelAi)

    return (

        <>

            <Stack direction={"column"} spacing={3}>
                {/* Seção de Modelo de IA */}

                {verifyRules(user?.rules, 'ia.modelo.customizado') && (
                    <ContainerOptions>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between">
                                <h3 className="text-lg font-semibold text-gray-900">Configuração de Modelo de IA</h3>
                                {aiAgent?.config?.generalConfig?.customModelAi && (
                                    <button
                                        onClick={() => {
                                            changeConfigTools({
                                                name: "customModelAi",
                                                value: null
                                            })
                                        }}
                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-md hover:bg-red-100 transition-colors"
                                    >
                                        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                        Limpar modelo
                                    </button>
                                )}
                            </div>

                            <div className="space-y-4">
                                {/* Status do modelo atual */}
                                {aiAgent?.config?.generalConfig?.customModelAi && (
                                    <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                                        <div className="flex items-center">
                                            <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                            <span className="text-sm font-medium text-green-800">
                                                Modelo ativo: {optionsModeloIA.find(opt => opt.value === aiAgent.config.generalConfig.customModelAi)?.label || 'Personalizado'}
                                            </span>
                                        </div>
                                    </div>
                                )}

                                {/* Seletor sempre visível */}
                                <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
                                    <div className="mb-3">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            {aiAgent?.config?.generalConfig?.customModelAi ? 'Alterar modelo de IA' : 'Selecionar modelo de IA'}
                                        </label>
                                        <p className="text-sm text-gray-600">
                                            {aiAgent?.config?.generalConfig?.customModelAi
                                                ? 'Escolha um novo modelo ou mantenha o atual.'
                                                : 'Escolha um modelo personalizado para este agente ou use as configurações padrão abaixo.'
                                            }
                                        </p>
                                    </div>

                                    <Select
                                        value={aiAgent?.config?.generalConfig?.customModelAi || null}

                                        placeholder="Modelo de IA"
                                        onValueChange={(e) => {
                                            let event = {
                                                name: "customModelAi",
                                                value: e
                                            }
                                            changeConfigTools(event)

                                        }}
                                    >
                                        <SelectTrigger className="w-1/3">
                                            <SelectValue placeholder="Escolha um modelo de IA..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {optionsModeloIA.map((option) => (
                                                <SelectItem key={option.value} value={option.value}>
                                                    <div className="flex flex-col">
                                                        <span className="font-medium">{option.label}</span>
                                                    </div>
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </ContainerOptions>
                )}


                {/* Seção de Tipo de Agente - Só mostra quando não há modelo personalizado */}
                {!aiAgent?.config?.generalConfig?.customModelAi && (
                    <ContainerOptions>
                        <div className="space-y-4">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">Tipo de Agente</h3>
                                <p className="text-sm text-gray-600">
                                    Configure o comportamento padrão do agente quando nenhum modelo personalizado estiver selecionado.
                                </p>
                            </div>

                            <RadioGroup
                                value={aiAgent?.config?.generalConfig?.agent_type}
                                onValueChange={(value) => !isTipoAgenteDisabled && changeAgentType(value)}
                                className="grid grid-cols-2 gap-4 w-full"
                                disabled={isTipoAgenteDisabled}
                            >
                                {optionsTipoAgente.map((option) => (
                                    <TooltipProvider key={option.value}>
                                        <Tooltip>
                                            <TooltipTrigger asChild>
                                                <div className={`w-full ${isTipoAgenteDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
                                                    <RadioGroupItem
                                                        value={option.value}
                                                        id={option.value}
                                                        className="peer sr-only"
                                                        disabled={isTipoAgenteDisabled}
                                                    />
                                                    <Label
                                                        htmlFor={option.value}
                                                        className={`flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-2 transition-all duration-200 ${isTipoAgenteDisabled
                                                            ? 'opacity-50 cursor-not-allowed'
                                                            : 'hover:bg-violet-500 hover:text-white cursor-pointer'
                                                            } ${aiAgent?.config?.generalConfig?.agent_type === option.value
                                                                ? 'bg-violet-500 text-white'
                                                                : ''
                                                            }`}
                                                    >
                                                        {option.label}
                                                    </Label>
                                                </div>
                                            </TooltipTrigger>
                                            <TooltipContent className="bg-slate-900 text-white">
                                                <p>{option.desc}</p>
                                                {isTipoAgenteDisabled && (
                                                    <p className="text-xs text-gray-300 mt-1">
                                                        Desabilitado quando um modelo de IA está selecionado
                                                    </p>
                                                )}
                                            </TooltipContent>
                                        </Tooltip>
                                    </TooltipProvider>
                                ))}
                            </RadioGroup>
                        </div>
                    </ContainerOptions>
                )}

                <ContainerOptions>
                    <Stack direction={"row"} spacing={2}>
                        <RowInput
                            sx={{ width: '100%' }}
                            label={"Audio como resposta"}
                            input={
                                <RadioGroup
                                    defaultValue={awnserAudio}
                                    value={awnserAudio}
                                    onValueChange={changeAwnserAudio}
                                    className="grid grid-cols-4 gap-4"
                                >
                                    {optionsTypeVoices.map((option) => (
                                        <div>
                                            <RadioGroupItem
                                                value={option.value}
                                                id={option.value}
                                                className="peer sr-only"
                                            />
                                            <Label
                                                htmlFor={option.value}
                                                className={`flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-2 hover:bg-accent hover:text-accent-foreground ${awnserAudio === option.value ? 'bg-violet-500 text-white' : ''}`}
                                            >
                                                {option.label}
                                            </Label>
                                        </div>
                                    ))}
                                </RadioGroup>
                            }
                        />
                        <RowInput
                            label={"Voz"}
                            input={<SelectVoice
                                listTypeVoices={listTypeVoices}
                                voice={voice}
                                changeVoice={(value) => {
                                    changeVoice(value)

                                }}
                            />}
                        />

                    </Stack>
                </ContainerOptions>

                <ContainerOptions>
                    <h4>
                        Conhecimento do Agente
                    </h4>
                    <p className="text-sm text-muted-foreground mb-4">
                        Configure quais conhecimentos o agente deve utilizar durante as conversas
                    </p>

                    <ZuiAlert
                        title="Atenção ao Consumo de Tokens"
                        className="bg-yellow-50"
                        description="O uso destas opções pode aumentar o consumo de tokens, impactando o custo das conversas. Ative apenas os conhecimentos essenciais para o seu caso de uso."
                        icon="eva:alert-triangle-fill"
                    />

                    <div className="grid grid-cols-2 gap-6 mt-4">

                        <div className="flex flex-row items-center justify-between p-4 border rounded-lg">
                            <div className="flex flex-col">
                                <label className="text-sm font-medium">Calendário</label>
                                <p className="text-xs text-muted-foreground">
                                    Permite que o agente tenha acesso a informações de calendário. Ideal para agendamentos. O uso desta opção pode aumentar o consumo de tokens.
                                </p>
                            </div>
                            <Switch
                                checked={aiAgent?.config?.generalConfig?.knowledge?.calendar?.status || false}
                                onCheckedChange={(value) => {
                                    let event = {
                                        name: "knowledgeCalendarStatus",
                                        value: value
                                    }
                                    changeConfigTools(event)
                                }}
                            />
                        </div>

                        <div className="flex flex-row items-center justify-between p-4 border rounded-lg">
                            <div className="flex flex-col">
                                <label className="text-sm font-medium">Serviços</label>
                                <p className="text-xs text-muted-foreground">
                                    Habilita o conhecimento sobre serviços
                                </p>
                            </div>
                            <Switch
                                defaultChecked={aiAgent?.config?.generalConfig?.tools?.calendar?.status}
                                onCheckedChange={(value) => {
                                    console.log(value, aiAgent?.config?.generalConfig?.tools?.calendar?.status)
                                    let event = {
                                        name: "toolServicesStatus",
                                        value: value
                                    }
                                    changeConfigTools(event)
                                }}
                            />
                        </div>

                        <div className="flex flex-row items-center justify-between p-4 border rounded-lg">
                            <div className="flex flex-col">
                                <label className="text-sm font-medium">Produtos</label>
                                <p className="text-xs text-muted-foreground">
                                    Habilita o conhecimento sobre produtos
                                </p>
                            </div>
                            <Switch
                                defaultChecked={aiAgent?.config?.generalConfig?.tools?.products?.status}
                                onCheckedChange={(value) => {
                                    let event = {
                                        name: "toolProductsStatus",
                                        value: value
                                    }
                                    changeConfigTools(event)
                                }}
                            />
                        </div>


                    </div>

                </ContainerOptions>




                <ContainerOptions>
                    <Stack spacing={{ xs: 2, md: 3 }}>

                        <Accordion type="single" collapsible className="w-full">
                            <AccordionItem value="item-1">
                                <AccordionTrigger>Configurações avançadas</AccordionTrigger>
                                <AccordionContent>

                                    <Stack direction={"row"}>
                                        <RowInput
                                            label={"Tempo de resposta do agente"}
                                            info="Tempo em segundos que o agente aguarda para processar a mensagem e responder"
                                            input={
                                                <div className="flex flex-row items-center">

                                                    <Input
                                                        value={aiAgent?.config?.generalConfig?.timeListenMsgs}
                                                        name="timeListenMsgs"
                                                        onChange={e => changeListenMsgs(e.target.value)}
                                                        fullWidth
                                                        className="w-1/3"
                                                        type="number"
                                                    />
                                                    <Label className="ml-2">segundos</Label>
                                                </div>
                                            }
                                        />


                                        <RowInput
                                            label={"Tempo de digitação do agente"}
                                            info="Tempo de delay que o agente demora para escrever as mensagens. Tempo padrão: 50"
                                            input={
                                                <div className="flex flex-row items-center">

                                                    <Input
                                                        value={aiAgent?.config?.generalConfig?.delayBetweenMsgs}
                                                        onChange={e => changeDelayBetweenMsgs(e.target.value)}
                                                        fullWidth
                                                        className="w-1/3"
                                                        type="number"
                                                    />
                                                    <Label className="ml-2">milisegundos</Label>
                                                </div>
                                            }
                                        />

                                        {awnserAudio === 'random' && (
                                            <div className="flex flex-row items-center gap-2">
                                                <RowInput
                                                    label={"Limite de envio de voz"}
                                                    info="Ativar limite de caracteres para envio de mensagens de voz"
                                                    input={
                                                        <div className="flex flex-row items-center gap-2 h-10">
                                                            <Switch
                                                                checked={aiAgent?.config?.generalConfig?.limitSendVoice || false}
                                                                onCheckedChange={changeLimitSendVoice}
                                                            />
                                                            <Label>Ativar limite</Label>
                                                        </div>
                                                    }
                                                />

                                                {aiAgent?.config?.generalConfig?.limitSendVoice && (
                                                    <RowInput
                                                        label={"Tamanho máximo da mensagem de voz"}
                                                        info="Número máximo de caracteres permitidos para que seja enviado mensagem de voz"
                                                        input={
                                                            <div className="flex flex-row items-center">
                                                                <Input
                                                                    value={aiAgent?.config?.generalConfig?.lengthSendVoice || 200}
                                                                    onChange={e => changeLengthSendVoice(e.target.value)}
                                                                    fullWidth
                                                                    className="w-1/3"
                                                                    type="number"
                                                                />
                                                                <Label className="ml-2">caracteres</Label>
                                                            </div>
                                                        }
                                                    />
                                                )}
                                            </div>

                                        )}

                                    </Stack>
                                    <Divider className="my-4" sx={{ borderStyle: 'dashed' }} />
                                    <div className="flex flex-row items-center gap-2 mt-4">
                                        <Switch
                                            defaultChecked={aiAgent?.config?.generalConfig?.lastContext}
                                            onCheckedChange={(value) => {
                                                changeLastContext(value)
                                            }}
                                        />
                                        <label className="text-sx">Inclusão de contexto de conversas passadas</label>

                                    </div>
                                </AccordionContent>
                            </AccordionItem>
                        </Accordion>


                        <Stack spacing={2}>
                            <RowInput
                                sx={{ width: '100%' }}
                                label="tipo de mensagens permitidas"
                                info="Selecione os tipos de mensagens que o agente pode receber"
                                input={<Autocomplete
                                    multiple
                                    value={newOptionsAllowsInChat}
                                    options={optionsAllowsInChat}
                                    onChange={(event, newValue) => {
                                        let newValues = newValue.map(item => item.value);
                                        changeAllowsInChat(newValues)
                                    }}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Badge key={option.value} {...getTagProps({ index })}>
                                                {option.label}
                                            </Badge>

                                        ))
                                    }
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                        />
                                    )}
                                />}
                            />


                        </Stack>
                        <Stack direction="column" spacing={2}>
                            <RowInput
                                sx={{ width: '100%' }}
                                label="Mensagem recusa envio de audios"
                                input={<Textarea
                                    multiline
                                    rows={3}
                                    name="msgs.msgBreakAudios"
                                    onChange={onChangeMsgs}
                                    value={aiAgent?.config?.generalConfig?.messages?.msgBreakAudios}
                                />}
                            />
                            <RowInput
                                sx={{ width: '100%' }}
                                label="Mensagem recusa envio de imagens"
                                input={<Textarea
                                    multiline
                                    onChange={onChangeMsgs}
                                    rows={3}
                                    name="msgs.msgImages"
                                    value={aiAgent?.config?.generalConfig?.messages?.msgImages}
                                    fullWidth
                                />}
                            />
                            <RowInput
                                sx={{ width: '100%' }}
                                label="Mensagem recusa envio de arquivos"
                                input={<Textarea
                                    multiline
                                    rows={3}
                                    size="small"
                                    name="msgs.msgBreakFiles"
                                    onChange={onChangeMsgs}
                                    value={aiAgent?.config?.generalConfig?.messages?.msgBreakFiles}
                                    fullWidth
                                />}
                            />
                            <RowInput
                                sx={{ width: '100%' }}
                                label="Mensagem direcionamento"
                                input={<Textarea
                                    multiline
                                    rows={3}
                                    size="small"
                                    name="msgs.msgAfterTargeting"
                                    onChange={onChangeMsgs}
                                    value={aiAgent?.config?.generalConfig?.messages?.msgAfterTargeting}
                                    fullWidth
                                />}
                            />
                        </Stack>
                    </Stack>
                </ContainerOptions>

                <ContainerOptions>
                    <h4>
                        Ferramentas de IA
                    </h4>

                    <div className="flex flex-col gap-8 mt-4">

                        <div className="flex flex-row items-center gap-2 mt-4">
                            <Switch
                                defaultChecked={aiAgent?.config?.generalConfig?.tools?.calendar?.status}
                                onCheckedChange={(value) => {
                                    console.log(value, aiAgent?.config?.generalConfig?.tools?.calendar?.status)
                                    let event = {
                                        name: "toolCalendarStatus",
                                        value: value
                                    }
                                    changeConfigTools(event)
                                }}
                            />
                            <label className="text-sx">Agendamento via calendário</label>

                        </div>
                        {aiAgent?.config?.generalConfig?.tools?.calendar?.status && (
                            <div className="flex flex-col gap-4">

                                <div>
                                    <label className="block text-sm font-medium">Calendário</label>
                                    <Select
                                        value={aiAgent?.config?.generalConfig?.tools?.calendar?.calendar_id}
                                        onValueChange={e => {
                                            let event = {
                                                name: "toolCalendarId",
                                                value: e
                                            }
                                            changeConfigTools(event)
                                        }}
                                        className="w-full"
                                    >
                                        <SelectTrigger className="w-full">
                                            <SelectValue placeholder="Vincule um calendário" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {calendars.map((channel) => (
                                                <SelectItem key={channel._id} value={channel._id}>
                                                    {channel.name}
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>


                                <RowInput
                                    label="Mensagens adicionais de confirmação"
                                    input={<Textarea
                                        multiline
                                        rows={6}
                                        onChange={e => {
                                            let event = {
                                                name: "toolCalendarMsgConfirm",
                                                value: e.target.value
                                            }
                                            changeConfigTools(event)
                                        }}
                                        value={aiAgent?.config?.generalConfig?.tools?.calendar?.toolCalendarMsgConfirm}
                                    />}
                                />

                            </div>
                        )}
                        <Divider sx={{ borderStyle: 'dashed' }} />
                    </div>
                </ContainerOptions>


            </Stack>
        </>

    )

}